import React from "react";
import { Container } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/Header";
import Footer from "./components/Footer";

const App: React.FC = () => {
  return (
    <>
      <Header />
      <ToastContainer />
      <Container className="my-2 font-nunito-eb">
        <Outlet />
      </Container>
      <Footer />
    </>
  );
};

export default App;
